import { render, staticRenderFns } from "./Ethnicity.vue?vue&type=template&id=bd82bcd2&scoped=true"
import script from "./Ethnicity.vue?vue&type=script&lang=js"
export * from "./Ethnicity.vue?vue&type=script&lang=js"
import style0 from "./Ethnicity.vue?vue&type=style&index=0&id=bd82bcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd82bcd2",
  null
  
)

export default component.exports